module.exports = __webpack_public_path__ + "static/img/lsks.5c7a257c.png";